import { reflect } from '@effector/reflect'
import { useUnit } from 'effector-react'
import styled from 'styled-components'

import { ModalBox } from '@shared/ui/ModalBox'

import iphoneWithLogo from 'src/assets/images/iphone_with_logo@3x.png'
import ButtonBottom from 'src/components/Buttons/ButtonBottom'
import { useScopedTranslation } from 'src/shared/lib/useScopedTranslation'
import { secondaryGrey } from 'src/theme/colors'
import { heading4_21, text1_16 } from 'src/theme/fonts'
import { convertPxToRem } from 'src/utils/responsiveHelpers'

import { locationRequested, modalClosed } from '../model/actions'

export function ShareYourLocation() {
  const t = useScopedTranslation('translation.auth.location')

  const close = useUnit(modalClosed)

  return (
    <ModalBox handleClick={close} dataTestProp="shareLocationModal">
      <Content>
        <HeaderContainer>
          <ImageWrapper>
            <Image
              src={iphoneWithLogo}
              alt="Phone with geo tag on the screen"
            />
          </ImageWrapper>
        </HeaderContainer>

        <Title>{t('title')}</Title>
        <Description>{t('description')}</Description>

        <Actions>
          <ConfirmButton title={t('confirm')} />
          <DismissButton title={t('dismiss')} />
        </Actions>
      </Content>
    </ModalBox>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;

  padding: ${convertPxToRem(42, 24, 12, 24)};
`

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const Image = styled.img`
  width: ${convertPxToRem(66)};
  height: ${convertPxToRem(120)};
`

const HeaderContainer = styled.div`
  align-items: center;
  margin-bottom: ${convertPxToRem(16)};
`

const Title = styled.span`
  ${heading4_21};
  text-align: center;
  margin-bottom: ${convertPxToRem(16)};
`

const Description = styled.div`
  ${text1_16};
  margin-bottom: ${convertPxToRem(35)};
  color: ${secondaryGrey};
`

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${convertPxToRem(8)};
`

const ConfirmButton = reflect({
  view: ButtonBottom,
  bind: {
    handleClick: locationRequested,
    theme: 'primary',
  },
})

const DismissButton = reflect({
  view: ButtonBottom,
  bind: {
    handleClick: modalClosed,
    theme: 'linkBlue',
  },
})
